import type { GenieKnowledgeEntry } from '../../types';

export const cidp: GenieKnowledgeEntry = {
  id: 'cidp',
  aliases: ['demyelinating_neuropathy'],
  name: 'CIDP',
  category: 'neuropatico',
  conversation: {
    headline:
      'Polineuropatía desmielinizante inflamatoria crónica — tratable con inmunoterapia (IVIg, corticoides, plasmaféresis).',
    edxHighlights: [
      'Desmielinización en ≥2 nervios motores (VCM <70% LIN, bloqueos, dispersión)',
      'Curso >8 semanas o ≥2 recaídas',
      'Variantes: multifocal (Lewis-Sumner), sensitiva pura, DADS',
      'EMG: denervación activa + PUMs neurogénicos crónicos',
    ],
    pearls: [
      'Un solo nervio con desmielinización en sitio de atrapamiento NO cuenta como CIDP.',
      'No confundir con neuropatía diabética o idiopática — CIDP es tratable.',
    ],
    differentials: [
      { name: 'GBS', distinguishingHint: 'curso agudo (<4 sem), debilidad máxima en 2–4 sem' },
      { name: 'CMT1', distinguishingHint: 'desmielinización uniforme bilateral, hereditaria, no tratable' },
      { name: 'Amiodarona', distinguishingHint: 'patrón desmielinizante por fármaco — suspender antes de IVIg' },
    ],
    nextSteps: [
      'Confirmar criterios EAN/PNS 2023',
      'Solicitar anticuerpos (anti-NF155, anti-contactina-1 si variantes atípicas)',
    ],
  },
  detail: {
    summary:
      'Neuropatía inflamatoria crónica con respuesta a inmunoterapia. Reconocimiento temprano cambia el pronóstico.',
  },
  orientationHints: {
    temporalFit: ['chronic'],
    whenToSuspect: 'Debilidad/síntomas sensitivos progresivos >2 meses con patrón desmielinizante',
  },
};
